import styled from 'styled-components';
import Colors from '@components/shared/Colors';

interface TextProps {
  color?: string;
}

export const H1 = styled.h1<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'Domaine';
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 120%;

  @media (max-width: 768px) {
    font-size: 30px;
    line-height: 34px;
  }
`;

export const H2 = styled.h2<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const H3 = styled.h3<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};

  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const H4 = styled.h4<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};

  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 140%;
  }
`;

export const H5 = styled.h5<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};

  font-family: 'BrownStd';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 1.5px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const H6 = styled.h6<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 138%;
`;

export const MetaTitle = styled.p<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const TextDivider = styled.div<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'BrownStd';
  font-weight: 700;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 10px;

  &:before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${Colors.ecru};
  }

  &:not(:empty):before {
    margin-right: 0.25em;
  }

  &:not(:empty):after {
    margin-left: 0.25em;
  }
`;

export const BodyBold = styled.p<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};

  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 150%;
    letter-spacing: 0;
  }
`;

export const Body = styled.p<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};

  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;

  a {
    font-weight: bold;
    color: ${Colors.lilac};
  }

  & > svg {
    vertical-align: middle;
    margin: 0 2px 2px;
  }

  ul {
    li {
      font-size: 14px;
      line-height: 150%;
      color: inherit;
    }
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SmallTitle = styled.p<TextProps>`
  color: ${(props) => props.color ?? Colors.navyBlue};
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  opacity: 0.5;
`;
